var React = require('react');
var ReactNative = require('react-native');
var NativeAppEventEmitter = require('./wrappers/NativeAppEventEmitter-wrapper');

var Animated = require('./wrappers/Animated')

var AppActions = require('./AppActions.js');
var PlatformConstants = require('./constants/PlatformConstants');
var Globals = require('./Globals');

var Icon = require('./wrappers/ReUpIcon');

var FeatureBuilder = require('./FeatureBuilder.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText');
var ReUpTabBar = require('./ReUpTabBar');
var ReUpTabContentContainer = require('./ReUpTabContentContainer');

var Feed = require('./feed.js');
var Menu = require('./menu.js');
var ProgressOverlay = require('./ProgressOverlay.js');
var CustomAlertOverlay = require('./CustomAlertOverlay.js');
var BundleInfo = require('./BundleInfo.js');
var Overlay = require('./Overlay.js');
var ReUpFloatingNavigator = require('./ReUpFloatingNavigator');
var Keyboard = require('./wrappers/Keyboard-wrapper');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
  MKSpinner,
} = MK;

var {
  AppRegistry,
  Text,
  View,
  PixelRatio,
  TouchableHighlight,
  TouchableOpacity,
  Image,
  ScrollView,
  DeviceEventEmitter,
  NetInfo,
  StyleSheet,
  Platform,
  StatusBar,
  NativeModules,
  Vibration,
  Dimensions,
} = ReactNative;

var Animated = require('./wrappers/Animated')
var Navigator = require('./wrappers/Navigator-wrapper');


var AmazonSNSManager = NativeModules.RNAmazonSNSManager;

var AppNavigator = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      restartApp : function(){alert("restartApp")},
    }
  },

  getInitialState : function()
  {
    return {
      menuContainerShown : false,
      menuContainerLayout : {x:0, y:0, width:0, height:0},
      currentLayout: {x:0, y:0, width:0, height:0},
      shouldRender: false,
      shouldShowCustomAlert: false,
      customAlertChildren: <View />,
      customAlertDidCancel: function() {},
      shouldShowSpinner: false,
      spinnerText: "",
      updateProgress: new Animated.Value(0),
      updateOpacity: new Animated.Value(0),
      updateHasStarted: false,
      updateProgress2: new Animated.Value(0),
      updateOpacity2: new Animated.Value(0),
      updateHasStarted2: false,
      networkConnected: true,
      shouldHideNetworkStatus: false,
    }
  },

  _bundleUpdateStartedListener : null,
  _bundleUpdateProgressListener : null,
  _bundleUpdateCompleteListener : null,
  _networkConnectivityChange : null,
  componentDidMount : function()
  {
    Globals.addHardwareBackListener(this.backPushed);
    AppActions.initialize(this.props.appManager, this);
    var thisThing = this;

    if( Platform.OS != 'web' )
    {
      this._networkConnectivityChange = NetInfo.addEventListener(
        'connectionChange',
        thisThing.handleNetworkConnectivityChange
      );

      NetInfo.isConnected.fetch().done((isConnected) => {
        thisThing.setState({networkConnected:isConnected});
      });
    }

    var thisThing = this;
    var appManager = this.props.appManager;
    appManager._eventEmitter.on('downloadStarted', this.downloadStarted, this)
    appManager._eventEmitter.on('downloadProgressed', this.downloadProgressed, this);
    appManager._eventEmitter.on('downloadCompleted', this.downloadCompleted, this)
    appManager.downloadNewResources();

    var locManager = appManager.getLocalizationManager();
    var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");

    if( Platform.OS == 'ios' ) AmazonSNSManager.addListener("didReceivePush");
    else
    {
      // DeviceEventEmitter.addListener(
      //   'didReceivePush',
      //   (deviceInfo) =>
      //   {
      //     thisThing.setDeviceInfo(deviceInfo);
      //   }
      // )
    }
    if( Platform.OS == "ios" )
    {
      this._bundleUpdateStartedListener = NativeAppEventEmitter.addListener(
        'bundleUpdateStarted',
        () =>
        {
          thisThing.setState({updateProgress : new Animated.Value(0), updateOpacity : new Animated.Value(0)});
          Animated.timing(
           thisThing.state.updateOpacity,
           {toValue: 1,
           duration:500},
          ).start(function()
          {

          });
        });
      this._bundleUpdateProgressListener = NativeAppEventEmitter.addListener(
        'bundleUpdateProgress',
        (data) =>
        {
          var ratio = parseFloat(data.progress/100);
          Animated.spring(
            thisThing.state.updateProgress,
            {
              toValue: thisThing.state.currentLayout.width * ratio,
              tension: 10,
              friction: 10,
            },
          ).start();
        });
      this._bundleUpdateCompleteListener = NativeAppEventEmitter.addListener(
        'bundleUpdateComplete',
        (data) =>
        {
          if( data.updateSuccess )
          {
            Animated.spring(
              thisThing.state.updateProgress,
              {
                toValue: thisThing.state.currentLayout.width,
                tension: 10,
                friction: 10,
              },
            ).start(function()
            {
              setTimeout(function()
              {
                Animated.timing(
                 thisThing.state.updateOpacity,
                 {toValue: 0,
                 duration:500},
                ).start(function()
                {
                  thisThing.showAlert("App Updated", "Please reopen your app to complete the update.", [okayString], [thisThing.props.restartApp])
                });
              }, 0)
            });
          }
          else
          {
            Animated.timing(
             thisThing.state.updateOpacity,
             {toValue: 0,
             duration:500},
            ).start(function()
            {

            });
          }
        });

        var appManager = this.props.appManager;
        var locManager = appManager.getLocalizationManager();
        var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");
        this._didReceivePushListener = NativeAppEventEmitter.addListener(
          'didReceivePush',
          this.didReceivePush
        )
    }
    else
    {
      if( DeviceEventEmitter )
      {
        this._bundleUpdateStartedListener = DeviceEventEmitter.addListener(
          'bundleUpdateStarted',
          () =>
          {
            thisThing.setState({updateProgress : new Animated.Value(0), updateOpacity : new Animated.Value(0)});
            Animated.timing(
             thisThing.state.updateOpacity,
             {toValue: 1,
             duration:500},
            ).start(function()
            {

            });
          });
        this._bundleUpdateProgressListener = DeviceEventEmitter.addListener(
          'bundleUpdateProgress',
          (data) =>
          {
            var ratio = parseFloat(data.progress/100);
            Animated.spring(
              thisThing.state.updateProgress,
              {
                toValue: thisThing.state.currentLayout.width * ratio,
                tension: 10,
                friction: 10,
              },
            ).start();
          });
        this._bundleUpdateCompleteListener = DeviceEventEmitter.addListener(
          'bundleUpdateComplete',
          (data) =>
          {
            if( data.updateSuccess )
            {
              Animated.spring(
                thisThing.state.updateProgress,
                {
                  toValue: thisThing.state.currentLayout.width,
                  tension: 10,
                  friction: 10,
                },
              ).start(function()
              {
                setTimeout(function()
                {
                  Animated.timing(
                   thisThing.state.updateOpacity,
                   {toValue: 0,
                   duration:500},
                  ).start(function()
                  {
                    thisThing.showAlert("App Updated", "Please reopen your app to complete the update.", [okayString], [thisThing.props.restartApp])
                  });
                }, 0)
              });
            }
            else
            {
              Animated.timing(
               thisThing.state.updateOpacity,
               {toValue: 0,
               duration:500},
              ).start(function()
              {

              });
            }
          });

          var appManager = this.props.appManager;
          var locManager = appManager.getLocalizationManager();
          var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");
          this._didReceivePushListener = DeviceEventEmitter.addListener(
            'didReceivePush',
            this.didReceivePush
          )
      }
    }

    if( typeof this.props.appLoadCompletion !== 'undefined' && this.props.appLoadCompletion != null )
    {
      var thisThing = this;
      this._didExecuteAppLoadCompletion = true;
      setTimeout(()=>
      {
        thisThing.props.appLoadCompletion(AppActions);
      }, 1000);
    }
  },

  _didExecuteAppLoadCompletion : false,
  componentWillReceiveProps : function(newProps)
  {
    if( typeof this.props.appLoadCompletion !== 'undefined' && this.props.appLoadCompletion != null )
    {
      var thisThing = this;
      this._didExecuteAppLoadCompletion = true;
      setTimeout(()=>
      {
        newProps.appLoadCompletion(AppActions);
      }, 1000);
    }
  },

  didReceivePush: function(data)
  {
    var pattern, patternLiteral, patternDescription;
    if (Platform.OS === 'android')
    {
      pattern = [0,2000];
    }
    else
    {
      pattern = [0];
    }
    Vibration.vibrate(pattern)
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");
    // alert(JSON.stringify(data.aps))
    if ( typeof data.aps.TransactionID !== 'undefined' )
    {
      var title = "Transaction Success!";
      var body = data.aps.alert;
      if( typeof data.aps.CreditUsed !== 'undefined' && typeof data.aps.PointsEarned !== 'undefined' )
      {
        title = data.aps.alert;
        body = "You spent " + locManager.localizedDollars(data.aps.CreditUsed) + " and earned " + locManager.localizedPoints(data.aps.PointsEarned) + "!";
      }
      else if( typeof data.aps.PointsEarned !== 'undefined' )
      {
        title = data.aps.alert;
        body = "You earned " + locManager.localizedPoints(data.aps.PointsEarned) + "!";
      }
      else if( typeof data.aps.PointsUsed !== 'undefined' && typeof data.aps.RewardName !== 'undefined' )
      {
        title = data.aps.alert;
        body = "You redeemed " + locManager.localizedPoints(data.aps.PointsUsed) + " for a " + data.aps.RewardName + "!";
      }
      else if( typeof data.aps.FreePoints !== 'undefined' )
      {
        title = data.aps.alert;
        body = "You earned " + locManager.localizedPoints(data.aps.FreePoints) + "!";
      }

      // data.aps.FirstName + ' ' + data.aps.UserName + ' ' + data.aps.CreditUsed + ' ' + data.aps.Subtotal + ' ' + data.aps.TipTotal + ' ' + data.aps.PointsEarned + ' ' + data.aps.TransactionID + ' ' + data.aps.FirstName + ' ' + data.aps.LastName + ' ' + data.aps.CurrentCredit + ' ' + data.aps.CurrentPoints + ' ' + data.aps.ServiceFee
      var thisThing = this;
      var customAlert =
        <ScrollView bounces={true} style={{margin:0,padding:2,marginLeft:10,marginRight:10}}
          keyboardShouldPersistTaps={true}
          keyboardDismissMode={"interactive"}>
          <View >
            <ReUpText appManager={appManager} isTitle={true} style={{marginTop:10, textAlign:'center'}}>
              {
                title
              }
            </ReUpText>
            <ReUpText appManager={appManager} style={{marginTop:10, textAlign:'center'}}>
              {body}
            </ReUpText>
            <View style={{flexDirection:'row', marginTop:4}}>
              <ReUpButton onPress={() => thisThing.hideAlert()} appManager={appManager} text={okayString} style={[{margin:10, flex:1}]} />
            </View>
          </View>
        </ScrollView>;
      AppActions.setCustomAlertShown(true, customAlert, );
    }
    else
    {
      this.showAlert(appManager.appName, data.aps.alert, [okayString])
    }
  },

  downloadStarted: function()
  {
    if(this.state.updateHasStarted2) return;

    this.setState({updateProgress2 : new Animated.Value(0), updateOpacity2 : new Animated.Value(0), updateHasStarted2: true});
    Animated.timing(
     this.state.updateOpacity2,
     {toValue: 1,
     duration:500},
    ).start(function()
    {

    });
  },

  downloadProgressed: function(data)
  {
    if( !this.state.updateHasStarted2 )
    {
      this.downloadStarted();
      return;
    }
    var thisThing = this;
    var ratio = parseFloat(data.progress/100);
    Animated.spring(
      thisThing.state.updateProgress2,
      {
        toValue: thisThing.state.currentLayout.width * ratio,
        tension: 10,
        friction: 10,
      },
    ).start();
  },

  downloadCompleted: function(data)
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    var okayString = locManager.localizedStringForKey("OK_ALERT_BUTTON");
    if( data.updateSuccess )
    {
      Animated.spring(
        thisThing.state.updateProgress2,
        {
          toValue: thisThing.state.currentLayout.width,
          tension: 10,
          friction: 10,
        },
      ).start(function()
      {
        setTimeout(function()
        {
          Animated.timing(
           thisThing.state.updateOpacity2,
           {toValue: 0,
           duration:500},
          ).start(function()
          {
            var oldRootFeature = thisThing.props.appManager.getRootFeature();
            thisThing.props.appManager.initialize(()=>
            {
              thisThing.setState({updateHasStarted2: false});

              // if the root feature has changed, restart the app
              var newRootFeature = thisThing.props.appManager.getRootFeature();
              if( typeof oldRootFeature !== 'undefined' && typeof oldRootFeature.data !== 'undefined'
                && typeof newRootFeature !== 'undefined' && typeof newRootFeature.data !== 'undefined'
                && newRootFeature.data.name != oldRootFeature.data.name ) thisThing.props.restartApp();
            })
          });
        }, 0)
      });
    }
    else
    {
      Animated.timing(
       thisThing.state.updateOpacity2,
       {toValue: 0,
       duration:500},
      ).start(function()
      {
        thisThing.setState({updateHasStarted2: false})
      });
    }
  },

  componentWillUnmount : function()
  {
    Globals.removeHardwareBackListener(this.backPushed);
    if( this._bundleUpdateStartedListener != null ) this._bundleUpdateStartedListener.remove();
    if( this._bundleUpdateProgressListener != null ) this._bundleUpdateProgressListener.remove();
    if( this._bundleUpdateCompleteListener != null ) this._bundleUpdateCompleteListener.remove();
    if( this._didReceivePushListener != null ) this._didReceivePushListener.remove();

    this.props.appManager._eventEmitter.removeListener('downloadStarted', this.downloadStarted, this);
    this.props.appManager._eventEmitter.removeListener('downloadProgressed', this.downloadProgressed, this);
    this.props.appManager._eventEmitter.removeListener('downloadCompleted', this.downloadCompleted, this);
  },

  stackIndex : function()
  {
    var stackIndex = typeof this._nav !== 'undefined' ? this._nav.state.routeStack.length-1 : 0;

    return stackIndex;
  },

  overrideMenuOpen : false,
  pushFeature : function(feature, extras, shouldAnimate)
  {
    if( typeof shouldAnimate === 'undefined' ) shouldAnimate = true;

    var thisThing = this;
    feature.extras = extras;
    AppActions.navLayout = thisThing.state.currentLayout;
    if( FeatureBuilder.featureCustomNavigation(feature, AppActions, thisThing.state.currentLayout, extras))
    {
      return;
    }

    if( this.props.appManager.shouldUseFloatingNav() )
    {
      if( this.props.appManager.shouldUseTab() )
      {
        var foundTab = -1;
        var tabFeatures = this.props.appManager.getTabFeatures();
        var overriddenFeature = this.props.appManager.getFeatureOverrideForName(feature.data.name, extras);
        var prerequisiteFeature = this.props.appManager.getPrerequisiteFeatureForName(overriddenFeature.featureName);
        if( prerequisiteFeature == null && (!feature.data.requiresLogin || this.props.appManager.isLoggedIn()) )
        {
          var featureName = overriddenFeature.featureName;
          extras = overriddenFeature.extras;
          for( var i = 0; i < tabFeatures.length; i++ )
          {
            var otherOverriddenFeature = this.props.appManager.getFeatureOverrideForName(tabFeatures[i].data.name, extras);
            if( otherOverriddenFeature.featureName == featureName )
            {
              foundTab = i;
              break;
            }
          }
          if( (foundTab >= 0 && !this._floatingNav.isShown() && this.stackIndex() <= 0) || (this._floatingNav.isShown()) )
          {
            if( foundTab >= 0 ) this._tabs.setTabSelected(foundTab, false);
            this._floatingNav.pushFeature(this.props.appManager.getFeatureForName(featureName), extras);
            return;
          }
        }

        var thisThing = this;
        setTimeout(()=>
        {
          thisThing._tabs.setTabSelected(-1, false);
        }, 200);
      }
      else
      {
        this._floatingNav.pushFeature(feature, extras);
        return;
      }
    }
    AppActions.closeDrawer();
    if( !shouldAnimate )
    {
      var routeStack = this._nav.state.routeStack;
      routeStack.push(feature);
      this._nav.immediatelyResetRouteStack(routeStack);
    }
    else
    {
      this._nav.push(feature);
    }

    var shouldUseTab = this.props.appManager.shouldUseTab();
    if( shouldUseTab )
    {
      this._tabs.setVisible(false);
      this._tabs.setTabSelected(-1);
      // this._tabsContent.hideFeature();
    }
  },

  backPushed : function()
  {
    if( typeof this._ref_spinner !== 'undefined' && this._ref_spinner.state.isVisible ) return true;
    if( this._ref_customAlertOverlay._didFadeIn )
    {
      this.hideAlert();
      return true;
    }
    else if( this.stackIndex() > 1 )
    {
      var currentFeature = this._nav.state.routeStack[this._nav.state.routeStack.length-1];
      if( typeof currentFeature !== 'undefined' )
      {
        var backOverride = FeatureBuilder.backOverrideForFeatureData(currentFeature);
        if( backOverride != null )
        {
          backOverride(this.props.appManager, AppActions);
          return true;
        }
      }
      if( this.stackIndex() > 2 )
      {
        this.popFeature();
        return true;
      }
    }

    if( this.props.appManager.shouldUseFloatingNav() )
    {
      if( this._floatingNav.isShown() )
      {
        this._floatingNav.popFeature();
        return true;
      }
    }

    return true;
  },

  popFeature : function()
  {
    Keyboard.dismiss();
    if( this.props.appManager.shouldUseFloatingNav() )
    {
      this._floatingNav.popFeature();
      return;
    }

    if( this.stackIndex() <= 0 )
    {
      return false;
    }
    AppActions.closeDrawer();

    var shouldUseTab = this.props.appManager.shouldUseTab();
    var stackIndex = this.stackIndex();
    if( shouldUseTab && stackIndex <= 1 )
    {
      this._tabs.setVisible(true);
    }


    this._nav.pop();

    return true;
  },

  popToIndex : function(index)
  {
    if( this.stackIndex() == 0 && this.props.appManager.shouldUseFloatingNav() )
    {
      if( index == 0 ) this._floatingNav.dismiss();
      return;
    }

    var routes = this._ref_mainNav.getCurrentRoutes();
    if( index < routes.length )
    {
      this._nav.popToRoute(routes[index]);
    }
  },

  setCurrentFeature : function(feature, extras)
  {
    AppActions.closeDrawer();
    feature.extras = extras;

    if( this.stackIndex() == 0 && this.props.appManager.shouldUseFloatingNav() )
    {
      this._ref_floatingNav.replace(feature, extras);
      return;
    }

    this._nav.replace(feature);
  },

  floatingNavDidDismiss : function()
  {
    if( this.props.appManager.shouldUseTab() ) this._tabs.setTabSelected(-1);
  },

  _resetConnectivityChangeTimeout: null,
  handleNetworkConnectivityChange : function(reach)
  {
    var isNotConnected = (reach == "none") || (reach == "NONE") || (reach === false);

    this._isNotConnected = isNotConnected;
    this.setState({networkConnected:!isNotConnected,shouldHideNetworkStatus:false})
    console.log(reach)
    if( isNotConnected )
    {
      if( this._resetConnectivityChangeTimeout != null ) clearTimeout(this._resetConnectivityChangeTimeout);

      var thisThing = this;
      this._resetConnectivityChangeTimeout = setTimeout(()=>
      {
        if( Platform.OS != 'web' )
        {
          NetInfo.removeEventListener(
            'connectionChange',
            thisThing.handleNetworkConnectivityChange
          );

          thisThing._networkConnectivityChange = NetInfo.addEventListener(
            'connectionChange',
            thisThing.handleNetworkConnectivityChange
          );
        }
      }, 3000)
    }
  },

  toggleMenu : function()
  {
    AppActions.toggleDrawer();
  },

  _menuExpanded : false,
  menuExpandedChanged : function(isExpanded)
  {
    this._menuExpanded = isExpanded;
    if( typeof this._nav._navBar !== 'undefined' ) this._nav._navBar.forceUpdate();

    if( this.state.isMenuExpanded != isExpanded )
    {
      // not needed anymore
      // this.setState({isMenuExpanded:isExpanded});
    }
  },

  showAlert: function(title, body, buttonTitles, actions, didCancel, hideFrame, disableBackgroundSelectionDismiss, titleFontSize, bodyFontSize, buttonFontSize)
  {
    var thisThing = this;
    buttonTitles = typeof buttonTitles === 'undefined' ? [] : buttonTitles;
    title = typeof title === 'undefined' ? "" : title;
    body = typeof body === 'undefined' ? "" : body;
    actions = typeof actions === 'undefined' ? [this.hideAlert] : actions;
    didCancel = typeof didCancel === 'undefined' ? function(){} : didCancel;
    var appManager = this.props.appManager;

    var titleStyle = {marginTop:10, textAlign:'center'};
    if( typeof titleFontSize !== 'undefined' ) titleStyle.fontSize = titleFontSize;

    var bodyStyle = {marginTop:10, textAlign:'center'};
    if( typeof bodyFontSize !== 'undefined' ) bodyStyle.fontSize = bodyFontSize;

    var addedButtonFontStyle = {};
    if( typeof addedButtonFontStyle !== 'undefined' ) addedButtonFontStyle.fontSize = buttonFontSize;

    var customAlert =
      <ScrollView bounces={true} style={{margin:0,padding:2,marginLeft:10,marginRight:10,flexBasis: "auto"}}
        keyboardShouldPersistTaps={true}
        keyboardDismissMode={"interactive"}>
        <View >
          <ReUpText appManager={appManager} isTitle={true} style={titleStyle}>
            {title}
          </ReUpText>
          <ReUpText appManager={appManager} style={bodyStyle}>
            {body}
          </ReUpText>
          <View style={{flexDirection:'row', marginTop:4}}>
          {
            buttonTitles.map(function(buttonTitle, index)
            {
              var isSecondary = buttonTitles.length > 1 && index == 0;
              return(<ReUpButton isSecondary={isSecondary} onPress={() => {if( typeof actions[index] != 'undefined' ) {actions[index]()} else {thisThing.hideAlert()}}} appManager={appManager} text={buttonTitle} style={[{margin:10, flex:1}]} {...addedButtonFontStyle} />)
            })
          }
          </View>
        </View>
      </ScrollView>;
    this.showCustomAlert(customAlert, didCancel, hideFrame, disableBackgroundSelectionDismiss);
  },

  showCustomAlert : function(customAlert, didCancel, hideFrame, disableBackgroundSelectionDismiss)
  {
    if( typeof this._ref_customAlertOverlay !== 'undefined' ) this._ref_customAlertOverlay.fadeIn(customAlert, didCancel, hideFrame, disableBackgroundSelectionDismiss);
  },

  showNetworkErrorAlert : function(okAction, didCancel)
  {
    var locManager = this.props.appManager.getLocalizationManager();
    var errorTitle = locManager.localizedStringForKey("NETWORK_FAIL_ALERT_TITLE");
    var errorBody = locManager.localizedStringForKey("NETWORK_FAIL_ALERT_BODY");
    var errorOkay = locManager.localizedStringForKey("OK_ALERT_BUTTON");

    this.showAlert(errorTitle,errorBody,[errorOkay],[okAction], didCancel)
  },

  hideAlert : function()
  {
    this._ref_customAlertOverlay.fadeOut();
  },

  viewDidLayout : function(info)
  {
    var currentLayout = info.nativeEvent.layout;
    var menuLayout = info.nativeEvent.layout;
    menuLayout.height -= Globals.LAYOUT_HEIGHT_ADJUSTMENT;
    currentLayout.height += Globals.LAYOUT_HEIGHT_ADJUSTMENT;
    // layout.height -= 64;//styles.floatView.top;
      if (typeof window.orientation != "undefined" && Math.abs(window.orientation)==0 ){
        if(this.state.orientation == "landscape"){
        document.location.reload();
      }
      this.setState({orientation:"portrait"});
    }else{
      if(this.state.orientation == "portrait"){
        document.location.reload();
      }
      this.setState({orientation:"landscape"});
    }

    if( currentLayout.width != this.state.currentLayout.width ||
        currentLayout.height != this.state.currentLayout.height)
    {
      this.setState({menuContainerLayout:menuLayout, currentLayout:currentLayout, shouldRender:true})
    }
  },

  _lastDoubleTouch : -1,
  _doubleTouchCount : 0,
  MULTI_TOUCH_TIME_THRESHOLD : 500,
  DEBUG_MENU_NUMBER_OF_TOUCHES : 5,
  showDebugIfEnoughTouches : function(timestamp)
  {
    // touch too long, reset
    if( this._lastDoubleTouch > 0 && (timestamp - this._lastDoubleTouch) > this.MULTI_TOUCH_TIME_THRESHOLD)
    {
      this._doubleTouchCount = 0;
      this._lastDoubleTouch = -1;
    }

    // show info
    this._doubleTouchCount++;
    if( this._doubleTouchCount >= this.DEBUG_MENU_NUMBER_OF_TOUCHES )
    {
      this._doubleTouchCount = 0;
      this._lastDoubleTouch = -1;
      var appManager = this.props.appManager;
      var resourceInfo = appManager.getResourceInfo();
      this.showCustomAlert(<View><Text style={{fontSize:12}}>{"Bundle Info\n\n" + BundleInfo + "\nResource Info\n\n" + resourceInfo}</Text></View>);

      return;
    }

    this._lastDoubleTouch = timestamp;
  },

  getLeftButtonState : function(isMenuExpanded, isAtRoot)
  {
    var isAtRoot = typeof isAtRoot === 'undefined' ? this.stackIndex() <= 0 : isAtRoot
    var isMenuExpanded = (typeof isMenuExpanded !== 'undefined' ? isMenuExpanded : this._menuExpanded) || this.overrideMenuOpen;
    var thisNav = this;


    if( !isAtRoot )
    {
      var retVal =
      {
        ionicIconName : null,
        iconName : "arrow-left",
        onPress : function(){
          AppActions.requestPop();
        },
      };
      return retVal;
    }
    else if( isMenuExpanded )
    {
      var retVal =
      {
        ionicIconName : null,
        iconName : "times",
        onPress : function(){
          thisNav.toggleMenu();
        },
      };
      return retVal;
    }
    else
    {
      var retVal =
      {
        ionicIconName : null,
        iconName : "bars",
        onPress : function()
        {
          thisNav.toggleMenu();
        }
      };
      return retVal;
    }
  },

  featureIsInStack: function(feature)
  {
    if( !this._nav ) return false;

    var routeStack = this._nav.state.routeStack;
    for( var i = 0, len = routeStack.length; i < len; i++ )
    {
      var thisFeature = routeStack[i];
      if( thisFeature.data.name == feature.data.name )
      {
        return true;
      }
    }

    return false;
  },

  featureForData : function(route, layout, appManager, extras)
  {
    return FeatureBuilder.featureForData(route, layout, appManager, extras)
  },

  _topRightDisabled:false,
  render: function()
  {
    var appManager = this.props.appManager;
    var locManager = appManager.getLocalizationManager();
    if( !this.state.shouldRender )
    {
      return <View key="container" style={styles.container} onLayout={this.viewDidLayout} />
    }
    var thisNav = this;
    var appManager = this.props.appManager;
    var shouldDisableNavHeader = appManager.shouldDisableNavHeader(this.stackIndex());
    var shouldUseTab = appManager.shouldUseTab();

    var NavigationBar = shouldDisableNavHeader ?
    {
      LeftButton: function(route, navigator, index, navState)
      {
        return <View />
      },
      RightButton: function(route, navigator, index, navState)
      {
        return <View />
      },
      Title: function(route, navigator, index, navState)
      {
        return <View />
      },
    }
    :
    {
      LeftButton: function(route, navigator, index, navState)
      {
        if( index == 0 && shouldUseTab ) return null;
        return <View
                style={Globals.TOP_LEFT_STYLE_ADJUSTMENT}>
                <ReUpIconButton ref={(leftButton) =>
                 {
                   if( leftButton != null ) leftButton.setState(thisNav.getLeftButtonState(undefined, index <= 0))
                 }} key={"leftNavButton"+index}
                 appManager={appManager}
                 type={2}
                  accessibilityLabel={locManager.localizedStringForKey("MENU_ACCESSIBILITY_BUTTON")}/>
                </View>;
      },

      RightButton: function(route, navigator, index, navState)
      {
        if( index == 0 && shouldUseTab ) return null;
        var topRightFeatures = appManager.getTopRightFeatures();
        if( topRightFeatures.length <= 0 ) return <View />;

        var feature = topRightFeatures[0];
        if( feature.data.name == route.data.name || typeof feature === 'undefined' ) return <View />;
        if( feature.data.requiresLogin && !appManager.isLoggedIn() ) return <View />;
        for( var i = 0, len = navState.routeStack.length; i < len && i < navState.routeStack.length; i++ )
        {
          var thisFeature = navState.routeStack[i];
          if( thisFeature.data.name == feature.data.name )
          {
            return <View />;
          }
        }

        var thisThing = this;
        var iconName = feature.data.icon.replace("fa-", "")
        var topRightButtonName = feature.data.title;
        if( typeof feature.data.shortTitle !== 'undefined' ) topRightButtonName = feature.data.shortTitle;
        var useText = topRightButtonName.length <= 5;
        return <MKButton maskColor={'transparent'}
                onPress={(evt) => {AppActions.requestFeatureName(feature.data.name)}}
                style={Globals.TOP_RIGHT_STYLE_ADJUSTMENT}>
                {
                  useText ?
                    <View style={[{width:60, margin:6, borderRadius:30, alignItems:'center', justifyContent:'center', flexDirection:'row', backgroundColor: appManager.getColorForKey("HeaderIconColor")}, Globals.TOP_RIGHT_INNER_STYLE_ADJUSTMENT]}>
                      <ReUpText isTitle={true} appManager={appManager} style={{color: appManager.getColorForKey("HeaderColor")}}>
                      {topRightButtonName}
                      </ReUpText>
                    </View>
                  :
                    <ReUpIconButton key={"rightButton"+index}
                      appManager={appManager}
                      type={4}
                      iconName={iconName}
                      iconSize={18}
                      onPress={function(){
                        if( thisThing._topRightDisabled ) return;
                        thisThing._topRightDisabled = true;
                        setTimeout(function()
                        {
                          thisThing._topRightDisabled = false;
                        },2000)
                        AppActions.requestFeatureName(feature.data.name);
                      }}
                       />
                }
                </MKButton>;
      },

      Title: function(route, navigator, index, navState)
      {
        if( index == 0 && shouldUseTab ) return null;
        if( route.data.headerImage && route.data.headerImage.trim().length > 0 )
        {
          var headerPath = appManager.absoluteResourceForPath(route.key+'/'+route.data.headerImage);
          if( route.key == "FeedPlus" || route.key == "PassHome" ) headerPath = appManager.absoluteResourceForPath('Feed'+'/'+'header.png');

          return (
            <View onStartShouldSetResponder={(evt) => {if( evt.nativeEvent.identifier == 2 || (Platform.OS != "ios" && evt.nativeEvent.identifier == 1)) thisNav.showDebugIfEnoughTouches(evt.nativeEvent.timestamp)}}
             style={[styles.navBarTitleContainer, {alignSelf:'stretch', flex:1, marginRight:Platform.OS != "ios" && Platform.OS != "web" ? 70 : 0}]}>
              <Image key={appManager.getImageKey("header")} style={[styles.navBarTitleImage]} resizeMode={"stretch"} source={{uri: headerPath}}/>
            </View>
          );
        }
        else
        {
          return (
            <View onStartShouldSetResponder={(evt) => {if( evt.nativeEvent.identifier >= 1) thisNav.showDebugIfEnoughTouches(evt.nativeEvent.timestamp)}}
              style={[styles.navBarTitleContainer, {alignSelf:'stretch', flex:1, marginRight:Platform.OS != "ios" && Platform.OS != "web" ? 70 : 0}]}>
              <View style={{alignSelf:'center'}}>
                <ReUpText appManager={appManager} isSuperTitle={true} shrinksAtLength={20} style={[styles.navBarTitleText, {color: appManager.getColorForKey("HeaderTitleColor")}]}>
                  {route.data.title}
                </ReUpText>
              </View>
            </View>
          );

        }
      },

    };

    var navStyles = Navigator.NavigationBar.Styles;
    if( Platform.OS == 'ios' )
    {
      navStyles.General.TotalNavHeight = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Left.LeftButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Left.RightButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Center.LeftButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Center.RightButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Right.LeftButton.height = Globals.NAV_BAR_HEIGHT;
      navStyles.Stages.Right.RightButton.height = Globals.NAV_BAR_HEIGHT;
    }

    var navBar = <Navigator.NavigationBar routeMapper={NavigationBar} navigationStyles={navStyles} style={[styles.navBar,{height:Globals.NAV_BAR_HEIGHT}, {backgroundColor:this.props.appManager.getColorForKey("HeaderColor")}, shouldDisableNavHeader ? {height:0, opacity:0, display:'none', pointerEvents:'none'} : {}]} />;
    var initialRoute = appManager.getRootFeature();
    var appNav = this;

    if( this.state.shouldShowSpinner && this._ref_customAlertOverlay )
    {
      // this._ref_customAlertOverlay.fadeOut();
    }

    var navSpacerLineColor = appManager.shouldDisableNavHeader(this.stackIndex()) ? 'transparent' : appManager.getColorForKey("HeaderTitleColor",0.1);

    var isFeedPlus = true;

    var addedContainerStyle = {top:0, left:0, bottom:0, right:0, position:'absolute'};
    var height = 0;
    var width = 0;
    try {
      height = window.innerHeight;
      width = window.innerWidth;
      if( height > 0 && width > 0 )
      {
        if( Platform.OS !== 'ios' && Platform.OS !== 'web' ) height -= 24; // status bar
        addedContainerStyle = {width,height}
      }
    } catch (e) {

    } finally {

    }

    return (
      <View key="container" style={[styles.container, addedContainerStyle]} onLayout={this.viewDidLayout}>
        <Navigator ref={(a)=>{if( a ) thisNav._nav = a}} key="mainNav" navigationBar={this.props.appManager.shouldUseFloatingNav() && !this.props.appManager.shouldUseTab() ? null : navBar} initialRoute={initialRoute} style={addedContainerStyle}
          onWillFocus={(route) =>
            {
              AppActions.closeDrawer();
              appNav.forceUpdate();
              if( typeof appNav._nav !== 'undefined' && typeof appNav._nav._navBar !== 'undefined' )
              {
                // appNav._nav._navBar.forceUpdate();
              }
            }}
          onDidFocus={(route) =>
            {
              if( appNav.overrideMenuOpen )
              {
                appNav.overrideMenuOpen = false;
                // if( typeof appNav._nav._navBar !== 'undefined' ) appNav._nav._navBar.forceUpdate();
              }

              // appNav.forceUpdate();

              if( typeof route === 'undefined' || route.key == 'Feed' || route.key == 'FeedPlus' || route.key == 'PassHome' ) appManager._eventEmitter.emit("checkUserChanged", {});
            }}
          renderScene={(route, navigator) =>
            {
              return (FeatureBuilder.featureForData(route, this.state.currentLayout, appManager, route.extras))
            }
          }
          configureScene={(route, routeStack) =>
            {
              if( typeof routeStack === 'undefined' ) routeStack = appNav._nav.state.routeStack;
              if( isFeedPlus && (routeStack.length <= 2) ) return Navigator.SceneConfigs.FloatFromRight

              return Navigator.SceneConfigs.PushFromRight
            }}
        />
        {
          shouldUseTab ?
            <ReUpTabBar ref={(a) => { this._tabs = a }} buttonFeatures={appManager.getTabFeatures()}
              inactiveBackgroundColor={appManager.getColorForKey("HeaderColor")}
              activeBackgroundColor={appManager.getColorForKey("HeaderColor")}
              rippleColor={appManager.getColorForKey("HeaderIconColor",0.4)}
              barColor={appManager.getColorForKey("ButtonPrimaryColor")}
              showX={true}
              showFeature={function(feature, index, extras)
              {
                AppActions.requestFeatureName(feature.data.name, extras, false, null, thisNav._floatingNav.isShown());
                // thisNav.setCurrentFeature(feature, extras);
                // thisNav._tabs.setTabSelected(index);
                // thisNav._tabsContent.showFeature(feature, {}, true, function()
                // {
                //   thisNav._tabs.setTabSelected(index)
                // }, function()
                // {
                //   thisNav._tabs.setTabSelected(-1)
                // })
              }}
              hideFeature={function()
              {
                thisNav.popToIndex(0);
                // thisNav._tabsContent.hideFeature()
              }}
              textColor={appManager.getColorForKey("HeaderTitleColor")}
              iconColor={'transparent'} style={{paddingTop:Globals.STATUS_BAR_HEIGHT, width:this.state.currentLayout.width,height:Globals.ACTION_BAR_HEIGHT,position:'absolute', top:0,left:0, right:0, pointerEvents:'none'}} />
            : null
        }
        <View style={{backgroundColor:navSpacerLineColor,width:this.state.currentLayout.width,height:1,position:'absolute', top:Globals.ACTION_BAR_HEIGHT-1,left:0}} />
        {
          shouldUseTab && false ?
            <ReUpTabContentContainer ref={(c) => { this._ref_tabsContent = c; }} appActions={AppActions}
              layout={this.state.currentLayout}
              appManager={appManager}
              activeTop={Globals.ACTION_BAR_HEIGHT}
              height={this.state.currentLayout.height - Globals.ACTION_BAR_HEIGHT}
              width={this.state.currentLayout.width} />
            : null
        }
        <ReUpFloatingNavigator ref={(a)=>{if( a != null ) this._floatingNav = a}} appManager={appManager} appActions={AppActions} style={{position:'absolute', left:0, top:shouldUseTab ? Globals.ACTION_BAR_HEIGHT : 0, width, height}} ignoreStatusBar={shouldUseTab} disableNavHeader={shouldUseTab} onDismiss={this.floatingNavDidDismiss} />
        {
          this.state.networkConnected || this.state.shouldHideNetworkStatus ?
          null
          :
          <TouchableOpacity activeOpacity={0.8} onPress={() => {thisNav.setState({shouldHideNetworkStatus:true})}} style={[styles.networkStatus, {backgroundColor:appManager.getColorForKey("HeaderIconColor"), alignItems:'center', justifyContent:'center', top:shouldDisableNavHeader ? Globals.STATUS_BAR_HEIGHT : Globals.ACTION_BAR_HEIGHT}]}>
            <View style={{paddingLeft:30,flex:1, alignItems:'center', justifyContent:'center'}}><ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:appManager.getColorForKey("HeaderColor")}}>{appManager.getLocalizationManager().localizedStringForKey("NO_CONNECTION_STATEMENT")}</ReUpText></View>
            <View style={{width:30}}><ReUpText appManager={typeof appManager === 'undefined' ? null : appManager} style={{color:appManager.getColorForKey("HeaderColor")}}>X</ReUpText></View>
          </TouchableOpacity>
        }
        <View style={styles.updateMeter}>
          <Animated.View style={{width:this.state.updateProgress, opacity:this.state.updateOpacity, height:2, backgroundColor:appManager.getColorForKey("HeaderIconColor")}} />
        </View>
        <View style={styles.updateMeter}>
          <Animated.View style={{width:this.state.updateProgress2, opacity:this.state.updateOpacity2, height:2, backgroundColor:appManager.getColorForKey("HeaderIconColor")}} />
        </View>
        <CustomAlertOverlay ref={(c) => { this._ref_customAlertOverlay = c; }} key="customAlert" isVisible={true} shouldHideTemporarily={this.state.shouldShowSpinner} cancelSelected={function(){AppActions.setCustomAlertShown(false); if( typeof appNav.state.customAlertDidCancel !== 'undefined' ) appNav.state.customAlertDidCancel();}} layout={this.state.currentLayout}>
          {this.state.customAlertChildren}
        </CustomAlertOverlay>
        <ProgressOverlay ref={(c) => { this._ref_spinner = c; }} key="spinner" isVisible={this.state.shouldShowSpinner} spinnerText={this.state.spinnerText} layout={this.state.currentLayout} appManager={appManager}/>
      </View>
    );
  }
});

var styles = StyleSheet.create({
  floatView: {
    position: 'absolute',
    backgroundColor:'transparent',
    flex:1,
    width:0,
    height:0,
    top: Globals.ACTION_BAR_HEIGHT,
    left: 0,
  },
  container: {
    alignItems: 'stretch',
    flex:1,
    alignSelf:'stretch'
  },
  messageText: {
    fontWeight: '500',
    padding: 15,
    marginTop: 50,
    marginLeft: 15,
  },
  button: {
    backgroundColor: 'white',
    padding: 15,
    borderBottomWidth: 1 / PixelRatio.get(),
    borderBottomColor: '#CDCDCD',
  },
  buttonText: {
  },
  navBar: {
    backgroundColor: 'grey',
    padding:0,
    flex:-1,
  },
  navBarTitleImage: {
    height:44,
    width:150,
    padding:0,
    flex:-1,
  },
  navBarTitleContainer:{
    alignItems:'center',
    justifyContent:'center',
  },
  navBarText: {
    marginVertical: 10,
  },
  navBarTitleText: {
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
  },
  navBarLeftButton: {
    flexDirection:'row',
    width:44,
    height:44,
    marginTop:6,
    borderRadius:22,
    alignItems:'center',
    justifyContent:'center',
    alignSelf:'center',
    backgroundColor:'transparent',
  },
  navBarRightButton: {
    paddingRight: 10,
    flexDirection:'row',
    width:44,
    alignItems:'center',
    justifyContent:'center',
    flex:-1,
  },
  navBarButtonText: {
    color: 'green',
    paddingLeft:2,
    paddingTop:2,
  },
  scene: {
    flex: 1,
    paddingTop: 20,
    backgroundColor: '#EAEAEA',
  },
  menuContainerShown: {
    opacity: 1,
  },
  updateMeter: {
    position:'absolute',
    flexDirection:'row',
    top:0,
    left:0,
    right:0,
    height:2,
    backgroundColor:'transparent'
  },
  networkStatus: {
    position:'absolute',
    flexDirection:'row',
    left:0,
    right:0,
    height:30,
  }
});

module.exports = AppNavigator;
